import {SmartSiteBaseApiV2} from "../SmartSiteBaseApiV2";

export class AutoCompleteItemApi extends SmartSiteBaseApiV2 {

    public get ControllerName(): any {
        return 'autoCompleteItem';
    }
    
}